import React from "react";
import CouponCode from "../couponCode";
import Button from "shared/components/button";
import { useStaticData } from "context/staticData";
import { PurchaseOrderLineItemPropTypes } from "./types";
import { getPurchaseOrderLinePriceForSummary } from "../utils";

function PurchaseOrderLineItem(props: PurchaseOrderLineItemPropTypes) {
  const staticData = useStaticData();

  return (
    <React.Fragment>
      <li className="paymentSummaryList_item">
        <CouponCode
          logEvent={props.logEvent}
          purchaseOrderLine={props.line}
          showCouponCode={props.showCouponCode}
          disableCouponActions={props.disableCouponActions}
          applyCouponCodeHandler={props.applyCouponCodeHandler}
          registrationParticipantId={props.registrationParticipantId}
        />

        <div className="paymentSummaryList_itemDetailsWrapper">
          <div className="paymentSummaryList_itemDetails">
            <p className="paymentSummaryList_itemDetails--ticket">
              {staticData.inventoryType[props.line.lineType]}
              {Boolean(props.line.quantity) && (
                <span className="paymentSummaryList_itemDetails--ticketQty">x {props.line.quantity}</span>
              )}
              {props.editClickHandler && <Button.Edit label={""} onClick={props.editClickHandler} />}
            </p>
            {props.originatingFormName && (
              <p className="paymentSummaryList_itemDetails--formName">{props.originatingFormName}</p>
            )}
          </div>
          <div className="paymentSummaryList_itemAmount">
            <p className="paymentSummaryList_itemAmount--value">{getPurchaseOrderLinePriceForSummary(props.line)}</p>
          </div>
        </div>
      </li>
    </React.Fragment>
  );
}

export default PurchaseOrderLineItem;
